export default __webpack_public_path__ + "static/icon-27-1-eff19ffc66ad2a773c37fc5734045f41.png";